<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  name: "BarChart",
  props: {
    options: {
      type: Object,
      default: () => {}
    },
    mainTitle: {
      type: String,
      default: ""
    },
    yTitle: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>

<style>
canvas {
  width: 100% !important;
}
</style>
